import { render, staticRenderFns } from "./PasswordChangeForm.vue?vue&type=template&id=16cd0256"
import script from "./PasswordChangeForm.vue?vue&type=script&lang=js"
export * from "./PasswordChangeForm.vue?vue&type=script&lang=js"
import style0 from "./PasswordChangeForm.vue?vue&type=style&index=0&id=16cd0256&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports